import {Grid} from '@mui/material';
import LandingComingSoon from './LandingComingSoon';
import LandingCta from './LandingCta';
import LandingFeature from './LandingFeature';
import LandingHero from './LandingHero';
import LandingProblem from './LandingProblem';
import LandingTemplate from './LandingTemplate';

interface LandingPageItem {
  component: React.FC;
  src: string;
}

export default function LandingPage() {
  const items: LandingPageItem[] = [
    {src: '/landing_robot.webp', component: LandingHero},
    {src: '/landing_problem.jpg', component: LandingProblem},
    {src: '/landing_feature.webp', component: LandingFeature},
  ];
  return (
    <Grid container direction="column" spacing={2}>
      {items.map((item, i) => (
        <LandingTemplate src={item.src} isReverse={i % 2 === 0} key={`LandingPage-${item.src}`}>
          <item.component />
        </LandingTemplate>
      ))}
      <LandingComingSoon />
      <LandingCta />
    </Grid>
  );
}
